import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';

import { User } from '@models/user';
import { UserService } from '../../../../_services/user.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreButtonComponent],
  selector: 'app-email-use-screen',
  templateUrl: './email-use-screen.component.html',
})
export class EmailUseScreenComponent implements OnInit {
  @Input() userData: User;
  userEmail: string;

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.$user.subscribe((user) => {
      this.userEmail =
        user.userDetails.email.address != undefined
          ? user.userDetails.email.address
          : 'email@gmail.com';
    });
  }
}
